const getters = {
  getActiveExposurePart: state => state.activeExposurePart,
  getExposurePartOptions: state => state.exposurePartOptions,
  getActiveExposureTable: state => state.activeExposureTable,
  getExposureTableOptions: state => state.exposureTableOptions,
  getActivePartBar: state => state.activePartBar,
  getPartBarOptions: state => state.partBarOptions,
  getActiveTypeEntityItem: state => state.activeTypeEntityItem,
  getActivePartBarUof: state => state.activePartBarUof,
  getActivePartBarFull: state => state.activePartBarFull,
  getActiveExposurePartUof: state => state.activeExposurePartUof,
  getActiveExposurePartFull: state => state.activeExposurePartFull,
  getActiveTypeEntityItemUof: state => state.activeTypeEntityItemUof,
  getActiveTypeEntityItemFull: state => state.activeTypeEntityItemFull,
}

export default getters